import * as React from 'react';

type Props = {
  message: string;
};

export const InfoIcon = ({ message }: Props) => {
  return <i className="fa-light fa-circle-info info-icon" title={message}></i>;
};
